import React, { useState } from "react";
import styled from "styled-components";
import { api } from "api";
import {
    FicInput,
    FicComboBox,
    FicNumber,
    FicDatePicker,
} from "../../Utils/FormInputComponents";
import Banner from "../common/Banner";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { validar } from "../../components/ValidarNit";
import GenBtn from "../../components/GenBtn";
import { crear, getPatologias } from "./actions";
import LoadMask from "../../Utils/LoadMask/LoadMask";
import { withRouter } from "react-router";
import { useEffect } from "react";
import { FicImageDropzone } from "../../Utils/FormInputComponents";
import { today, getLocalTimeZone } from "@internationalized/date";
import OptionsBar from "../common/OptionsBar";

const BANNER_TEXT = "Asociar laminas a patologia";

const schema = yup.object({
    patologia: yup.mixed().required("La patologia es requerida"),
    fecha_ingreso: yup.mixed().required("La fecha de ingreso es requerida"),
    laminas: yup
        .array()
        .when("patologia", {
            is: (val) => val && val.tipo !== "Citologia",
            then: () => yup.mixed().notRequired(),
        })
        .when("patologia", {
            is: (val) => val && val.tipo === "Inmunohistoquimica",
            then: () =>
                yup
                    .array()
                    .min(1, "Debe subir al menos una lamina")
                    .max(
                        1,
                        "Solo puede subir una lamina para inmunohistoquimica"
                    )
                    .required("Las laminas son requeridas"),

            otherwise: (y) =>
                yup
                    .array()
                    .min(1, "Debe subir al menos una lamina")
                    .required("Las laminas son requeridas"),
        }),
});

const InputsContainer = styled.div`
    background-color: #2b2b2b;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-radius: 5px;
    min-width: 400px;
    max-width: 100%;

    @media (min-width: 768px) {
        display: grid;
        grid-template-areas:
            "patologia patologia  fecha"
            "laminas laminas laminas ";
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
`;

function Crear({ history, ...props }) {
    const [isLoading, setIsLoading] = useState(false);
    const { control, reset, handleSubmit, setValue, watch, formState } =
        useForm({
            mode: "onChange",
            resolver: yupResolver(schema),
            defaultValues: {
                patologia: null,
                fecha_ingreso: today(getLocalTimeZone()).toString(),
                laminas: [],
            },
        });

    async function onSubmit(data) {
        setIsLoading(true);
        data.patologia = data.patologia.value;
        await crear(data);
        reset();
        setIsLoading(false);
    }

    return (
        <React.Fragment>
            <OptionsBar />
            <Banner>{BANNER_TEXT}</Banner>
            <GenBtn
                onPress={() => history.goBack()}
                style={{ margin: "5px 0" }}
            >
                Regresar
            </GenBtn>
            <LoadMask loading={isLoading} color="#bd0034" blur={true}>
                <form
                    encType="multipart/form-data"
                    onSubmit={handleSubmit(onSubmit)}
                    style={{ display: "flex", flexDirection: "column" }}
                >
                    <InputsContainer style={{}}>
                        <FicComboBox
                            control={control}
                            label="Patologia"
                            name="patologia"
                            loadOptions={getPatologias}
                            componentStyle={{ gridArea: "patologia" }}
                        />
                        {/* <FicComboBox
                            control={control}
                            label="Paciente"
                            name="paciente"
                            loadOptions={getPacientes}
                        /> */}

                        <FicDatePicker
                            control={control}
                            label="Fecha de ingreso"
                            name="fecha_ingreso"
                            componentStyle={{ gridArea: "fecha" }}
                        />
                        <FicImageDropzone
                            control={control}
                            label="Laminas"
                            name="laminas"
                            style={{ gridArea: "laminas" }}
                        />
                    </InputsContainer>
                    <GenBtn style={{ margin: "1rem 0" }} type="submit">
                        Guardar
                    </GenBtn>
                </form>
            </LoadMask>
        </React.Fragment>
    );
}
export default withRouter(Crear);
